  (function () {
    var lb = document.getElementById('SneaklyLB');
    if (!lb || lb.dataset.init) return;
    lb.dataset.init = '1';
    var track = document.getElementById('SneaklyLBTrack');
    var slides = Array.prototype.slice.call(track.querySelectorAll('.sneakly-lb__slide'));
    var imgs = Array.prototype.slice.call(track.querySelectorAll('.sneakly-lb__img'));
    var curEl = lb.querySelector('.sneakly-lb__cur');
    var closeBtn = lb.querySelector('.sneakly-lb__close');
    var prevBtn = lb.querySelector('.sneakly-lb__nav--prev');
    var nextBtn = lb.querySelector('.sneakly-lb__nav--next');
    var mid2idx = {};
    imgs.forEach(function (im, i) { mid2idx[im.getAttribute('data-mid')] = i; });
    // 🚨 DESKTOP (user 2026-08-04: "pan w zoomie zaczyna przenosic zdjecie
    // z przegladarki"): pointerowy preventDefault NIE gasi natywnego drag&drop
    // obrazka - trzeba draggable=false na kazdym img + ubicie dragstart.
    imgs.forEach(function (im) { im.setAttribute('draggable', 'false'); });
    lb.addEventListener('dragstart', function (e) { e.preventDefault(); });

    var index = 0, trackW = 0;
    var zoom = imgs.map(function () { return { sc: 1, tx: 0, ty: 0 }; });

    // --- doladowywanie: 320 (placeholder) -> 1280 (widok) -> 2048 (zoom aktywnego) ---
    // podmiana src DOPIERO gdy nowa wersja jest zdekodowana - inaczej przegladarka
    // potrafi na moment pokazac pusty obraz (mrugniecie przy 320->1280->2048)
    // 🚨 pre.decode() PRZED przypisaniem src: sama obecnosc pliku w cache nie
    // wystarcza - przegladarka dekoduje bitmape dopiero po przypisaniu i na duzym
    // zdjeciu (2048) potrafi pokazac pusta klatke. Dekodujemy w tle, dopiero potem
    // podmieniamy - podmiana jest wtedy natychmiastowa i niewidoczna.
    function swapWhenReady(im, url, cb) {
      if (!im || !url) { if (cb) cb(); return; }
      if (im.getAttribute('src') === url) { if (cb) cb(); return; }
      var pre = new Image();
      var applied = false;
      var apply = function () {
        if (applied) return;
        applied = true;
        if (im.getAttribute('src') !== url) im.setAttribute('src', url);
        if (cb) cb();
      };
      pre.onload = function () {
        if (pre.decode) {
          pre.decode().then(apply).catch(apply);
          setTimeout(apply, 400); // decode() potrafi nie rozwiazac sie w tle - nie blokuj jakosci
        } else apply();
      };
      pre.onerror = function () { if (cb) cb(); };
      pre.src = url;
    }
    function load(k) { if (k < 0 || k >= imgs.length) return; var im = imgs[k], s = im.getAttribute('src'); if (im.dataset.src && s !== im.dataset.src && s !== im.dataset.full) swapWhenReady(im, im.dataset.src); }
    function upgrade(k, cb) { if (k < 0 || k >= imgs.length) { if (cb) cb(); return; } var im = imgs[k]; if (im.dataset.full) swapWhenReady(im, im.dataset.full, cb); else if (cb) cb(); }
    function loadNear(i) { load(i); load(i + 1); load(i - 1); load(i + 2); }

    function applyTrack(px, anim) {
      // ten sam charakter co slider PDP: wystrzal + wyrazne hamowanie.
      // Y2=1 (bylo 1.1): user 2026-08-11 - zdjecie ma sie ZATRZYMAC na pozycji
      // koncowej, nie wyjezdzac 10% dalej i wracac (overshoot z Y2>1).
      track.style.transition = anim ? 'transform 0.2s cubic-bezier(0.93,0.06,0.45,1)' : 'none';
      track.style.transform = 'translate3d(' + px + 'px,0,0)';
    }
    function applyImg(i) {
      var z = zoom[i];
      imgs[i].style.transform = 'translate3d(' + z.tx + 'px,' + z.ty + 'px,0) scale(' + z.sc + ')';
      // kursor-afordancja jak w PhotoSwipe (desktop): lupka przy 1:1, krzyzyk w zoomie
      imgs[i].classList.toggle('snkl-zoomed', z.sc > 1.01);
    }
    // animowane dojscie do zadanego zoomu (smycz pinchu + double-tap); na czas
    // zywego gestu transition MUSI byc zdjety, inaczej sledzenie palcow plywa
    function setImgTransition(i, on) {
      imgs[i].style.transition = on ? 'transform 0.32s cubic-bezier(0.22, 0.9, 0.28, 1)' : 'none';
    }
    function animateImgTo(i, sc, tx, ty) {
      var z = zoom[i]; z.sc = sc; z.tx = tx; z.ty = ty; clampZoom(i);
      setImgTransition(i, true);
      applyImg(i);
      var im = imgs[i];
      var done = function () { im.style.transition = 'none'; im.removeEventListener('transitionend', done); };
      im.addEventListener('transitionend', done);
      setTimeout(done, 420); // bezpiecznik, gdyby transitionend nie doszlo
    }
    function clampZoom(i) {
      var z = zoom[i], im = imgs[i];
      var mx = Math.max(0, (im.clientWidth * z.sc - im.clientWidth) / 2);
      var my = Math.max(0, (im.clientHeight * z.sc - im.clientHeight) / 2);
      z.tx = Math.max(-mx, Math.min(mx, z.tx)); z.ty = Math.max(-my, Math.min(my, z.ty));
    }
    function updNav() { /* sterowanie zawsze aktywne - nawigacja zapetlona */ }
    function goTo(i, anim) {
      var was = index;
      index = Math.max(0, Math.min(imgs.length - 1, i));
      // strzalki/klawiatura przy aktywnym zoomie: opuszczany slajd wraca do 1:1
      // (swipe robi to przez panToSwipe; tu domykamy pozostale drogi zmiany slajdu)
      if (was !== index && zoom[was].sc > 1) animateImgTo(was, 1, 0, 0);
      applyTrack(-index * trackW, anim);
      curEl.textContent = (index + 1);
      loadNear(index); upgrade(index); updNav();
    }
    function measure() { trackW = lb.clientWidth; }

    // MORPH: klikniete zdjecie "przesuwa sie" ze swojego miejsca na srodek ekranu.
    // Klon w opakowaniu z overflow:hidden - opakowanie skaluje sie z kadru miniatury
    // do docelowego kadru, a obraz w srodku dostaje ODWROTNA skale, wiec sam but ani
    // sie nie rozciaga, ani nie skacze; zmienia sie tylko wyciecie kadru.
    // Tlo lightboxa = tlo zdjec (#E7E7E7), wiec widac wylacznie ruch buta.
    // 🚨 BEZ overshootu w ZADNYM kierunku (decyzja usera 2026-07-30). Krzywa z y2 > 1
    // przelatywalaby za stan koncowy, czyli zdjecie na moment robiloby sie wieksze
    // niz docelowy kadr - a tego wlasnie nie chcemy. Szybki start, wyrazne hamowanie,
    // koniec dokladnie na kadrze.
    // 🚨 TEMPO LOTU (user 2026-08-08: "animacja przejscia do lightboxa za malo
    // plynna na mobile", "za szybko zdjecie przesuwa sie na srodek").
    // Bylo: 220ms i krzywa (0.22,0.9,...), ktora startuje z nachyleniem ~4x -
    // zdjecie ruszalo z pelna predkoscia od pierwszej klatki, wiec na telefonie
    // (gdzie droga klon->srodek jest najdluzsza w stosunku do ekranu) oko widzialo
    // skok zamiast lotu. Teraz krzywa "emphasized": start z ZERA, mocne
    // przyspieszenie w srodku i dlugie hamowanie - to standard dla przejscia
    // typu container transform, czyli dokladnie tego, co tu robimy.
    // Nadal BEZ overshootu (y2 = 1, decyzja usera 2026-07-30) - zdjecie nie
    // przelatuje ponad docelowy kadr.
    var MORPH_EASE = 'cubic-bezier(0.2,0,0,1)';
    var MORPH_EASE_BACK = 'cubic-bezier(0.4,0,0.7,1)';
    var MORPH_DUR = 420;
    // powrot krotszy niz wejscie: jezyk marki - znika zwawiej niz wchodzi
    var MORPH_DUR_BACK = 300;

    function reduced() {
      return window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
    // Geometria docelowego kadru (object-fit: contain).
    // 🚨 Liczymy z PUDELKA DOCELOWEGO OBRAZKA, nie z calego lightboxa: na desktopie
    // slajd ma padding (zeby zdjecie nie wchodzilo pod licznik i sterowanie), wiec
    // pomiar po lb.clientWidth/Height dawal kadr o kilkanascie procent za duzy i klon
    // ladowal obok prawdziwego zdjecia.
    function fitRect(nw, nh, targetEl) {
      var box = null;
      if (targetEl && targetEl.getBoundingClientRect) {
        var tr = targetEl.getBoundingClientRect();
        if (tr.width && tr.height) box = tr;
      }
      var vx = box ? box.left : 0, vy = box ? box.top : 0;
      var vw = box ? box.width : lb.clientWidth, vh = box ? box.height : lb.clientHeight;
      var k = Math.min(vw / nw, vh / nh);
      var fw = nw * k, fh = nh * k;
      return { w: fw, h: fh, x: vx + (vw - fw) / 2, y: vy + (vh - fh) / 2 };
    }
    // klon lecacy miedzy miniatura a kadrem pelnoekranowym.
    // back=false: miniatura -> srodek; back=true: srodek -> miniatura
    // obraz zdekodowany (albo bezpiecznik)
    function whenDecoded(im, cb) {
      if (!im) return cb();
      if (im.complete && im.naturalWidth) {
        if (im.decode) { im.decode().then(cb).catch(cb); } else cb();
        return;
      }
      var done = false;
      var fin = function () { if (done) return; done = true; cb(); };
      im.addEventListener('load', fin, { once: true });
      im.addEventListener('error', fin, { once: true });
      setTimeout(fin, 300);
    }
    // 🚨 Klon trzymamy do momentu, az docelowe zdjecie ma JUZ FINALNY src (2048)
    // i jest zdekodowane. Wczesniej odslanialismy male zdjecie, a podmiana na duze
    // nastepowala PO odslonieciu - stad "znika i pojawia sie jeszcze raz".
    function whenReady(im, cb) {
      if (!im) return cb();
      var done = false;
      var fin = function () { if (done) return; done = true; cb(); };
      setTimeout(fin, 500); // nie trzymamy klona w nieskonczonosc przy wolnej sieci
      var full = im.dataset.full;
      if (full && im.getAttribute('src') !== full) {
        swapWhenReady(im, full, function () { whenDecoded(im, fin); });
      } else {
        whenDecoded(im, fin);
      }
    }
    // 🚨 Zrodlowa miniatura MUSI zniknac na czas lotu klona. Odkad klon leci NAD
    // lightboxem, przez pierwsze klatki (tlo jeszcze pol-przezroczyste) bylo widac
    // pod nim oryginalne zdjecie produktowe = "widmo" ciagnace sie za butem.
    // Przywracamy przy hardClose (otwarcie) albo tuz przed zdjeciem klona (zamkniecie).
    var hiddenThumbs = [];
    function hideThumb(im) {
      if (!im || hiddenThumbs.indexOf(im) > -1) return;
      im.style.visibility = 'hidden';
      hiddenThumbs.push(im);
      // 🚨 znaczniki na zdjeciu (NOWOSC / WYPRZEDANE / promocja; user 2026-08-04:
      // "karta przechodzi jakby przez ten tag") znikaja RAZEM z miniatura na czas
      // lotu klona i wracaja w restoreThumbs. Flagi PDP siedza na WRAPPERZE
      // galerii (main-product.liquid, przed render product-media-gallery),
      // nie w media-itemie - stad zasieg po .product__media-wrapper.
      var wrap = im.closest && im.closest('.product__media-wrapper');
      if (wrap) {
        var tags = wrap.querySelectorAll('.pdp-flag, .sneakly-flag, .sneakly-size-tag, .badge');
        for (var ti = 0; ti < tags.length; ti++) {
          if (hiddenThumbs.indexOf(tags[ti]) === -1) { tags[ti].style.visibility = 'hidden'; hiddenThumbs.push(tags[ti]); }
        }
      }
    }
    function restoreThumbs() {
      hiddenThumbs.forEach(function (im) { im.style.visibility = ''; });
      hiddenThumbs = [];
    }
    // 🚨 `preRect` = prostokat zmierzony ZANIM zablokowano przewijanie. Patrz
    // komentarz w open(): `overflow: hidden` na <html> zabija `position: sticky`
    // galerii, wiec pomiar zrobiony pozniej zwraca pozycje BAZOWA, nie te widoczna.
    function flyClone(srcImg, back, onEnd, readyImg, preRect) {
      var s = preRect || srcImg.getBoundingClientRect();
      if (!s.width || !s.height) { if (onEnd) onEnd(); return; }
      hideThumb(srcImg);
      // 🚨 Kadr docelowy liczymy z obrazka W LIGHTBOXIE i z JEGO wymiarow naturalnych.
      // Wczesniej brany byl srcImg, czyli MINIATURA - a galeria pokazuje kwadratowy
      // kadr, wiec przy zdjeciach 3:4 proporcje sie rozjezdzaly i przy powrocie klon
      // startowal z zlego, powiekszonego kadru.
      var lbImg = readyImg || imgs[index];
      var nw = (lbImg && lbImg.naturalWidth) || srcImg.naturalWidth || s.width;
      var nh = (lbImg && lbImg.naturalHeight) || srcImg.naturalHeight || s.height;
      var f = fitRect(nw, nh, lbImg);
      var wrap = document.createElement('div');
      wrap.className = 'sneakly-lb__morph';
      wrap.style.cssText = 'left:' + f.x + 'px;top:' + f.y + 'px;width:' + f.w + 'px;height:' + f.h + 'px;';
      var im = document.createElement('img');
      im.src = srcImg.currentSrc || srcImg.src;
      im.alt = '';
      wrap.appendChild(im);
      document.body.appendChild(wrap);
      var sx = s.width / f.w, sy = s.height / f.h;
      var dx = (s.left + s.width / 2) - (f.x + f.w / 2);
      var dy = (s.top + s.height / 2) - (f.y + f.h / 2);
      var thumbT = 'translate(' + dx + 'px,' + dy + 'px) scale(' + sx + ',' + sy + ')';

      // 🚨 SKALA OBRAZU W KADRZE MINIATURY.
      // Miniatura w galerii renderuje sie przez object-fit: COVER w kwadracie,
      // a zdjecie w lightboxie przez CONTAIN - to DWIE rozne skale obrazu:
      //   kf = skala w lightboxie (contain), kt = skala w miniaturze (cover).
      // Wczesniej licznik byl `1/sx, 1/sy`, co utrzymywalo obraz w STALEJ skali
      // lightboxa przez caly lot. Na mobile to przypadkiem pasowalo (kwadrat na
      // pelnej szerokosci => kf == kt), ale na desktopie na koncu ZAMYKANIA
      // w okienku miniatury siedzialo zdjecie narysowane w rozmiarze z lightboxa,
      // czyli powiekszony wycinek nietrafiajacy w to, co jest pod spodem.
      // q = kt/kf domyka te roznice; net = (sx*q/sx, sy*q/sy) = (q, q), wiec
      // skala jest JEDNORODNA i but sie nie rozjezdza.
      var kf = Math.min(f.w / nw, f.h / nh);
      var kt = Math.max(s.width / nw, s.height / nh);
      var q = (kf > 0 && isFinite(kt / kf)) ? (kt / kf) : 1;
      var thumbI = 'scale(' + (q / sx) + ',' + (q / sy) + ')';
      // stan poczatkowy
      wrap.style.transform = back ? 'none' : thumbT;
      im.style.transform = back ? 'none' : thumbI;

      // Zwykla tranzycja, BEZ wybicia rozmiaru (decyzja usera 2026-07-30 - wczesniej
      // byly tu keyframe'y z BUMP 1.07 w polowie lotu). Krzywa tez nie przelatuje
      // za stan koncowy, wiec zdjecie nigdzie sie nie powieksza ponad docelowy kadr.
      var dur = back ? MORPH_DUR_BACK : MORPH_DUR;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          var ease = back ? MORPH_EASE_BACK : MORPH_EASE;
          wrap.style.transition = 'transform ' + dur + 'ms ' + ease;
          im.style.transition = 'transform ' + dur + 'ms ' + ease;
          wrap.style.transform = back ? thumbT : 'none';
          im.style.transform = back ? thumbI : 'none';
        });
      });
      setTimeout(function () {
        // 🚨 KOLEJNOSC: najpierw odslon prawdziwe zdjecie (jest POD klonem, wiec
        // nic nie widac), dopiero po 2 klatkach usun klon. Odwrotna kolejnosc
        // dawala jedna klatke pustki = mrugniecie na koniec animacji.
        whenReady(readyImg, function () {
          if (onEnd) onEnd();
          // klon znika 2 klatki po odslonieciu; setTimeout to bezpiecznik na wypadek,
          // gdyby rAF nie tykal (karta w tle) - inaczej klon zawislby na ekranie
          var killed = false;
          var kill = function () {
            if (killed) return;
            killed = true;
            if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
          };
          requestAnimationFrame(function () { requestAnimationFrame(kill); });
          setTimeout(kill, 120);
        });
      }, dur + 30);
    }
    function morph(srcImg, preRect) {
      if (!srcImg || !srcImg.getBoundingClientRect || reduced()) return;
      lb.classList.add('is-morphing');
      // readyImg = docelowe zdjecie w lightboxie: odslaniamy je dopiero po dekodowaniu
      flyClone(srcImg, false, function () { lb.classList.remove('is-morphing'); }, imgs[index], preRect);
    }
    // miniatura w galerii odpowiadajaca AKTUALNEMU zdjeciu w lightboxie
    function galleryImgFor(i) {
      var im = imgs[i];
      var mid = im && im.getAttribute('data-mid');
      if (!mid) return null;
      var items = document.querySelectorAll('.product__media-list .product__media-item');
      for (var k = 0; k < items.length; k++) {
        if (items[k].getAttribute('data-media-id') === mid) return items[k].querySelector('img');
      }
      return null;
    }

    function open(idx, srcImg) {
      // 🚨 POMIAR MUSI BYC PIERWSZY. Ponizej ustawiamy `overflow: hidden` na
      // <html> i <body>, co odbiera galerii kontener przewijania - a wtedy jej
      // `position: sticky` przestaje dzialac i zdjecie wraca na pozycje bazowa.
      // Zmierzone na PDP przy przewinieciu 900 px: miniatura skakala o 755 px
      // (top 48 -> -708), wiec klon startowal spoza ekranu i animacja szarpala.
      var preRect = (srcImg && srcImg.getBoundingClientRect) ? srcImg.getBoundingClientRect() : null;
      zoom.forEach(function (z) { z.sc = 1; z.tx = 0; z.ty = 0; });
      imgs.forEach(function (_, i) { applyImg(i); });
      lb.hidden = false; lb.classList.remove('is-closing'); lb.classList.add('is-open'); lb.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden'; document.body.style.overflow = 'hidden';
      document.body.classList.add('snkl-lb-open'); // chowa czat (Shopify Inbox)
      measure();
      [idx, idx + 1, idx - 1, idx + 2, idx - 2].forEach(load);
      setTimeout(function () { imgs.forEach(function (_, i) { load(i); }); }, 250);
      index = Math.max(0, Math.min(imgs.length - 1, idx));
      applyTrack(-index * trackW, false);
      curEl.textContent = (index + 1);
      upgrade(index); updNav();
      morph(srcImg, preRect);
    }
    function hardClose() {
      // przywracamy PRZED zdjeciem klona (onEnd leci przed kill) - zdjecie w galerii
      // jest z powrotem na miejscu zanim klon zniknie, wiec nie ma pustej klatki
      restoreThumbs();
      lb.classList.remove('is-open'); lb.classList.remove('is-closing'); lb.classList.remove('is-morphing');
      lb.hidden = true; lb.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = ''; document.body.style.overflow = '';
      document.body.classList.remove('snkl-lb-open');
    }
    // zamkniecie = ten sam ruch w druga strone: zdjecie wraca na SWOJA miniature.
    // Galeria jest wczesniej przewijana na biezacy indeks, wiec klon ladauje
    // dokladnie tam, gdzie po zamknieciu stoi zdjecie (nic sie nie nakłada).
    // 🚨 DESKTOP: nieaktywne kadry galerii maja `display: none` od 750 px (patrz
    // komentarz "TYLKO DESKTOP" w product-media-gallery.liquid). Miniatura zdjecia,
    // ktore user oglada w lightboxie, ma wiec prostokat 0x0, warunek `widoczna`
    // ponizej wypadal falszywie i zamkniecie lecialo BEZ animacji - dokladnie to
    // zglosil wlasciciel 2026-09-09 ("animacja zamykania zniknela, a miala byc taka
    // jak otwierania"). Lekarstwo: najpierw ustawiamy to zdjecie jako aktywne w
    // galerii (to samo robi klikniecie miniatury, wiec zadnej nowej logiki), a
    // dopiero potem mierzymy. Efekt uboczny jest pozadany: po zamknieciu galeria
    // stoi na tym zdjeciu, ktore user ogladal.
    function aktywujWGalerii(i) {
      var im = imgs[i];
      var mid = im && im.getAttribute('data-mid');
      if (!mid) return;
      var gal = document.querySelector('media-gallery');
      if (!gal || typeof gal.setActiveMedia !== 'function') return;
      var cel = document.querySelector('.product__media-list [data-media-id="' + mid + '"]');
      if (!cel || cel.classList.contains('is-active')) return;
      try { gal.setActiveMedia(mid, false); } catch (err) {}
    }

    function close() {
      if (lb.classList.contains('is-closing')) return;
      // 🚨 Odblokuj przewijanie PRZED pomiarem - inaczej sticky galerii jest
      // wciaz zapadniete i `widoczna` ponizej wypada falszywie, przez co
      // zamkniecie leci bez animacji. `hardClose` i tak czysci to ponownie.
      document.documentElement.style.overflow = ''; document.body.style.overflow = '';
      aktywujWGalerii(index);
      var src = reduced() ? null : galleryImgFor(index);
      if (src) {
        var strip = document.querySelector('.product__media-wrapper ul.product__media-list');
        if (strip) {
          var it = strip.querySelector('.product__media-item');
          if (it && it.clientWidth) {
            var prevBeh = strip.style.scrollBehavior;
            strip.style.scrollBehavior = 'auto';
            strip.scrollLeft = index * it.clientWidth;
            strip.style.scrollBehavior = prevBeh;
          }
        }
        var r = src.getBoundingClientRect();
        var widoczna = r.bottom > 0 && r.top < innerHeight && r.width > 0;
        // Galeria bywa poza kadrem w PIONIE (user przewinal strone, zanim zamknal).
        // Skaczemy do niej BEZ smooth: animacja lotu ma sie zaczac od prostokata,
        // ktory juz jest na ekranie, a nie gonic przewijanie w trakcie.
        if (!widoczna && r.width > 0) {
          var doGory = r.top + window.scrollY - Math.max(0, (innerHeight - r.height) / 2);
          window.scrollTo({ top: Math.max(0, doGory), behavior: 'auto' });
          r = src.getBoundingClientRect();
          widoczna = r.bottom > 0 && r.top < innerHeight && r.width > 0;
        }
        if (widoczna) {
          lb.classList.add('is-closing');
          flyClone(src, true, hardClose);
          return;
        }
      }
      // Nie ma do czego leciec (brak miniatury, `prefers-reduced-motion`, galeria
      // przebudowana przy zmianie wariantu). Zamiast ciac obraz w jednej klatce
      // wygaszamy go - zamkniecie zawsze ma ruch, nigdy przeskok.
      if (!reduced()) {
        lb.classList.add('is-closing');
        lb.classList.add('is-closing--fade');
        window.setTimeout(hardClose, 200);
        return;
      }
      hardClose();
    }

    // siec bezpieczenstwa: gdyby natywny lightbox Dawn (product-modal) jednak wstal - zamknij
    function closeDawnModal() {
      var pm = document.querySelector('product-modal[open], product-modal.active, .product-modal[open]');
      if (!pm) return;
      try { if (typeof pm.hide === 'function') pm.hide(); else { pm.removeAttribute('open'); pm.style.display = 'none'; } } catch (err) {}
    }

    // klik na GLOWNEJ galerii -> otworz nasz lightbox, zablokuj modal Dawn
    document.addEventListener('click', function (e) {
      if (lb.classList.contains('is-open')) return;
      var hit = e.target.closest('.product__media-list .product__media-item');
      if (!hit) return;
      // strażnik "tapniecie zatrzymujace wybieg" USUNIETY 2026-08-07 razem
      // z JS-owym przejmowaniem gestu w galerii: przy natywnym przewijaniu to
      // WebKit tlumi klik, ktory zatrzymuje momentum, wiec nie ma czego pilnowac.
      var mid = hit.getAttribute('data-media-id');
      var idx = (mid != null && mid2idx[mid] != null) ? mid2idx[mid] : 0;
      e.preventDefault(); e.stopImmediatePropagation();
      open(idx, hit.querySelector('img')); // <- zdjecie startowe morfa
      closeDawnModal(); setTimeout(closeDawnModal, 30); setTimeout(closeDawnModal, 120);
    }, true);

    closeBtn.addEventListener('click', close);
    // nawigacja ZAPETLONA (jak slider na stronie): z ostatniego na pierwsze i odwrotnie
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index <= 0 ? imgs.length - 1 : index - 1, true); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index >= imgs.length - 1 ? 0 : index + 1, true); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') goTo(index + 1, true);
      else if (e.key === 'ArrowLeft') goTo(index - 1, true);
    });
    window.addEventListener('resize', function () { if (!lb.classList.contains('is-open')) return; measure(); applyTrack(-index * trackW, false); });

    // --- zunifikowana obsluga wskaznika: swipe (track) | pinch/pan (aktywny slajd) ---
    // 🚨 MUTEX DWUPALCOWY (user 2026-08-04: pinch + przejazd w prawo przelaczal
    // zdjecie): Safari podczas gestu potrafi utrzymac ZYWY strumien pointerow
    // jednego palca - ten palec sam robil swipe rownolegle z pinchem. Liczba
    // fizycznych palcow z TOUCHOW to prawda absolutna: przy >=2 pojedyncze
    // pointery nie moga uzbroic ani dokonczyc swipe'a.
    var fingersDown = 0;
    ['touchstart', 'touchmove', 'touchend', 'touchcancel'].forEach(function (tt) {
      lb.addEventListener(tt, function (e) { fingersDown = (e.touches && e.touches.length) || 0; }, { passive: true });
    });
    var pts = new Map(), mode = null;
    var swStartX = 0, swBaseX = 0, swMoved = 0;
    var panLX = 0, panLY = 0;
    var piDist = 0, piScale = 1, piMid = null, piCenter = null, piTx = 0, piTy = 0;
    function twoPts() { return Array.prototype.slice.call(pts.values()); }
    var vSamples = [], pendingX = null, rafId = null;
    function scheduleTrack(x) { pendingX = x; if (rafId) return; rafId = requestAnimationFrame(function () { rafId = null; if (pendingX !== null) { applyTrack(pendingX, false); pendingX = null; } }); }
    function swipeVelocity() { if (vSamples.length < 2) return 0; var a = vSamples[vSamples.length - 2], b = vSamples[vSamples.length - 1]; var dt = b.t - a.t; return dt > 0 ? (b.x - a.x) / dt : 0; }
    // HANDOFF pan->swipe (user 2026-08-04: w zoomie z double-tapa swipe ma NADAL
    // dzialac): pan dobija do POZIOMEJ krawedzi zdjecia, palec ciagnie dalej
    // (nadwyzka >34px w akumulatorze panOver) -> plynne przejscie w swipe;
    // opuszczany slajd wraca smycza do 1:1, wiec nastepne zdjecie otwiera sie
    // normalnie bez zooma, a powrot tez zastaje to zdjecie czyste.
    var panOver = 0;
    function panToSwipe(x) {
      animateImgTo(index, 1, 0, 0);
      mode = 'swipe';
      panOver = 0;
      swStartX = x; swBaseX = -index * trackW; swMoved = 0;
      vSamples = [{ x: x, t: Date.now() }];
      applyTrack(swBaseX, false);
    }

    track.addEventListener('pointerdown', function (e) {
      pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
      /* 🚨 Przechwytywanie wskaznika TYLKO przy jednym palcu. Safari na iOS
         potrafi zdusic drugi pointerdown, gdy pierwszy pointer jest przechwycony
         na tym samym elemencie — wtedy pinch nigdy sie nie uruchamia. Przy
         drugim palcu zwalniamy wszystkie przechwycenia i przechodzimy w pinch. */
      if (pts.size === 1) {
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
      } else {
        pts.forEach(function (_, id) {
          try { if (track.hasPointerCapture && track.hasPointerCapture(id)) track.releasePointerCapture(id); } catch (err) {}
        });
      }
      if (pts.size === 2) {
        mode = 'pinch';
        // 🚨 jak w tpArm/gesturestart: skasuj zawieszona klatke swipe'a i WYROWNAJ
        // tasme do biezacego slajdu - bez tego pinch startowal na tasmie
        // przesunietej w polowie przewijania i sasiedni slajd wystawal z boku
        // (zrzut usera 2026-08-04)
        if (rafId) { cancelAnimationFrame(rafId); rafId = null; pendingX = null; }
        applyTrack(-index * trackW, false);
        setImgTransition(index, false); // zywy gest bez wygladzania (przerywa tez animacje smyczy)
        var a = twoPts();
        piDist = Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y);
        var z = zoom[index]; piScale = z.sc; piTx = z.tx; piTy = z.ty;
        piMid = { x: (a[0].x + a[1].x) / 2, y: (a[0].y + a[1].y) / 2 };
        var r = imgs[index].getBoundingClientRect();
        piCenter = { x: r.left + r.width / 2, y: r.top + r.height / 2 };
      } else if (pts.size === 1) {
        if (fingersDown >= 2) { mode = null; } // fizycznie 2 palce = gest dwupalcowy, nie swipe/pan
        // 🚨 W ZOOMIE (double-tap) DOTYK: o trybie decyduje DOMINUJACA OS
        // pierwszych ~8px gestu (user 2026-08-04: poziomo = NORMALNY swipe do
        // kolejnego zdjecia od razu; pionowo = pan widoku). MYSZ: drag = pan
        // w OBU osiach od razu (user 2026-08-04: "po double tap na desktop nie
        // moge przesuwac zooma, od razu wychodzi w swipe") - zmiana slajdu
        // mysza w zoomie przez przeciagniecie ZA krawedz (panOver) lub strzalki.
        else if (zoom[index].sc > 1) { mode = (e.pointerType === 'mouse') ? 'pan' : 'panpend'; panLX = e.clientX; panLY = e.clientY; panOver = 0; swMoved = 0; setImgTransition(index, false); }
        else { mode = 'swipe'; swStartX = e.clientX; swBaseX = -index * trackW; swMoved = 0; vSamples = [{ x: e.clientX, t: Date.now() }]; applyTrack(swBaseX, false); }
      }
    });
    track.addEventListener('pointermove', function (e) {
      if (!pts.has(e.pointerId)) return;
      pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (mode === 'pinch') {
        e.preventDefault();
        // PRZYROSTOWO (user 2026-08-04): skala wokol BIEZACEGO srodka palcow
        // + widok WEDRUJE za przesuwajacymi sie palcami (pan zdjecia, nie tasmy).
        // Wzor: nowy t = (m - c) - (mPop - c - t) * (sc'/sc), gdzie m = centroid,
        // c = srodek zdjecia; punkt zdjecia spod centroidu zostaje pod palcami.
        var a = twoPts(); var d = Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y);
        var m = { x: (a[0].x + a[1].x) / 2, y: (a[0].y + a[1].y) / 2 };
        if (!piDist) { piDist = d; piMid = m; return; }
        var z = zoom[index];
        var ns = Math.min(4, Math.max(1, z.sc * (d / piDist))); var q = ns / z.sc;
        z.tx = (m.x - piCenter.x) - (piMid.x - piCenter.x - z.tx) * q;
        z.ty = (m.y - piCenter.y) - (piMid.y - piCenter.y - z.ty) * q;
        z.sc = ns; piDist = d; piMid = m;
        clampZoom(index); applyImg(index);
      } else if (mode === 'panpend') {
        e.preventDefault();
        var pdx = Math.abs(e.clientX - panLX), pdy = Math.abs(e.clientY - panLY);
        if (pdx < 8 && pdy < 8) return; // za wczesnie na decyzje o osi
        if (pdx > pdy) { panToSwipe(e.clientX); } // poziomo = normalny swipe (zoom schodzi smycza)
        else { mode = 'pan'; swMoved = 99; } // 99 = marker "byl drag" dla guarda klikniec (desktop strzela click po dragu)
      } else if (mode === 'pan') {
        if (tpPan) return; // pan prowadzi dotyk (fallback Safari); pointer zostaje dla myszy
        e.preventDefault();
        // akumulacja ruchu dla guarda klikniec: realny pan (>6px sumarycznie)
        // ma zbic click po pointerup; jitter dbl-clicka (1-2px) nie moze
        swMoved += Math.abs(e.clientX - panLX) + Math.abs(e.clientY - panLY);
        var z2 = zoom[index];
        var cand = z2.tx + (e.clientX - panLX);
        var im2 = imgs[index];
        var mx2 = Math.max(0, (im2.clientWidth * z2.sc - im2.clientWidth) / 2);
        var cl2 = Math.max(-mx2, Math.min(mx2, cand));
        panOver += cand - cl2; // nadwyzka ZA krawedzia - akumulowana miedzy eventami
        z2.tx = cl2;
        z2.ty += e.clientY - panLY;
        panLX = e.clientX; panLY = e.clientY;
        clampZoom(index); applyImg(index);
        if (Math.abs(panOver) > 34) { panToSwipe(e.clientX); return; }
      } else if (mode === 'swipe') {
        if (fingersDown >= 2) { // drugi palec fizycznie na ekranie: swipe przerwany, tasma wraca
          mode = null;
          if (rafId) { cancelAnimationFrame(rafId); rafId = null; pendingX = null; }
          applyTrack(-index * trackW, false);
          return;
        }
        swMoved = e.clientX - swStartX;
        var x = swBaseX + swMoved;
        // lekki opor na krancach
        if ((index === 0 && swMoved > 0) || (index === imgs.length - 1 && swMoved < 0)) x = swBaseX + swMoved * 0.35;
        scheduleTrack(x);
        vSamples.push({ x: e.clientX, t: Date.now() });
        if (vSamples.length > 6) vSamples.shift();
      }
    });
    function onUp(e) {
      if (!pts.has(e.pointerId)) return;
      pts.delete(e.pointerId);
      // guard klikniec (patrz handler 'click') potrzebuje swMoved TYLKO dla
      // clicka strzelanego zaraz po pointerup - tick pozniej zerujemy, zeby
      // stara wartosc nie zjadala klikniec BEZ pointerdown (czytniki ekranu,
      // syntetyczne aktywacje)
      if (pts.size === 0) setTimeout(function () { swMoved = 0; }, 0);
      if (mode === 'pinch') {
        // SMYCZ (user 2026-08-04): puszczenie CHOCBY JEDNEGO palca konczy pinch
        // animowanym powrotem do 1:1 - zoom dziala "na przytrzymanie". Trwaly
        // zoom daje tylko double-tap (i tam jednym palcem dziala pan).
        animateImgTo(index, 1, 0, 0);
        mode = null;
        return;
      } else if (mode === 'pan' || mode === 'panpend') {
        if (pts.size === 0) mode = null;
      } else if (mode === 'swipe') {
        if (pts.size === 0) {
          if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
          // 🚨 POZIOMY PINCH wchodzil w DWA tryby naraz (user 2026-08-04):
          // pierwszy palec przez ulamek sekundy byl "swipem" i szybko jechal
          // w bok, a gdy Safari przejmowalo gest, slalo pointerCANCEL - ponizsza
          // logika liczyla predkosc i odpalala goTo(next) ROWNOLEGLE z
          // uzbrajajacym sie pinchem (zoom + przeskok slajdu jednoczesnie).
          // Cancel albo uzbrojony juz pinch/gesture NIGDY nie jest flickiem:
          // wracamy na biezacy slajd i tyle.
          if (e.type === 'pointercancel' || tpActive || gsActive || fingersDown >= 2) {
            goTo(index, true);
            mode = null;
            return;
          }
          var vel = swipeVelocity(); // px/ms - flick nawet przy malym dystansie
          var th = trackW * 0.14;
          if (vel < -0.35 || swMoved < -th) goTo(index + 1, true);
          else if (vel > 0.35 || swMoved > th) goTo(index - 1, true);
          else goTo(index, true);
          mode = null;
        }
      }
    }
    track.addEventListener('pointerup', onUp);
    track.addEventListener('pointercancel', onUp);

    // --- MOBILE PINCH: dwie znane blokady na prawdziwych telefonach (2026-08-04,
    // user: "na mobile nie da sie zrobic pinch to zoom") ---
    // (1) iOS Safari: pinch STRONY odpala sie MIMO touch-action:none na tracku
    //     i przechwytuje gest zanim dojda pointery - gdy lightbox otwarty,
    //     gasimy natywne gesty (nasz zoom je zastepuje; poza lightboxem
    //     systemowe powiekszanie strony dziala bez zmian).
    // 🚨 RUNDA 3 (2026-08-04, user na iPhone/Safari: double-tap zoomuje, pinch
    // martwy => JS zyje, ale dwupalcowe touche/pointery NIE dochodza). Safari
    // ma wlasny, systemowy rozpoznawacz gestow: GestureEvent z gotowym e.scale
    // i centroidem (clientX/Y). Robimy z niego PELNOPRAWNY sterownik zoomu -
    // dziala nawet gdy Safari nie dostarczy ani pointerow, ani touchy.
    // Inne przegladarki tych zdarzen nie znaja (dalej jedzie pointer/touch).
    var gsActive = false, gsScale = 1, gsTx = 0, gsTy = 0, gsMid = null, gsCenter = null;
    lb.addEventListener('gesturestart', function (e) {
      if (!lb.classList.contains('is-open')) return;
      e.preventDefault();
      gsActive = true; tpActive = false; mode = null;
      // 🚨 Safari przejmuje strumien pointerow na czas gestu i NIE odda pointerup
      // - nasza mapa robi sie klamstwem. Czyscimy ja od razu (patrz resync nizej).
      pts.forEach(function (_, id) {
        try { if (track.hasPointerCapture && track.hasPointerCapture(id)) track.releasePointerCapture(id); } catch (err) {}
      });
      pts.clear();
      if (rafId) { cancelAnimationFrame(rafId); rafId = null; pendingX = null; }
      applyTrack(-index * trackW, false);
      setImgTransition(index, false); // zywy gest bez wygladzania
      gsScale = 1; // model przyrostowy: e.scale jest skumulowane i startuje od 1
      gsMid = { x: e.clientX || (lb.clientWidth / 2), y: e.clientY || (lb.clientHeight / 2) };
      var r = imgs[index].getBoundingClientRect();
      gsCenter = { x: r.left + r.width / 2, y: r.top + r.height / 2 };
    });
    lb.addEventListener('gesturechange', function (e) {
      if (!gsActive) return;
      e.preventDefault();
      // PRZYROSTOWO (user 2026-08-04): e.scale jest SKUMULOWANE od gesturestart,
      // wiec krok = e.scale/gsScale; centroid (clientX/Y) WEDRUJE z palcami
      // i panuje widok zdjecia - jak w sterownikach pointer/touch
      var m = { x: (typeof e.clientX === 'number' && e.clientX) || gsMid.x, y: (typeof e.clientY === 'number' && e.clientY) || gsMid.y };
      var s = e.scale || gsScale;
      var z = zoom[index];
      var ns = Math.min(4, Math.max(1, z.sc * (s / gsScale))); var q = ns / z.sc;
      z.tx = (m.x - gsCenter.x) - (gsMid.x - gsCenter.x - z.tx) * q;
      z.ty = (m.y - gsCenter.y) - (gsMid.y - gsCenter.y - z.ty) * q;
      z.sc = ns; gsScale = s; gsMid = m;
      clampZoom(index); applyImg(index);
    });
    lb.addEventListener('gestureend', function (e) {
      if (!gsActive) return;
      e.preventDefault();
      gsActive = false;
      animateImgTo(index, 1, 0, 0); // smycz
      mode = null;
    });
    lb.addEventListener('touchmove', function (e) {
      if (lb.classList.contains('is-open') && e.touches && e.touches.length > 1) e.preventDefault();
    }, { passive: false });
    // (2) FALLBACK DOTYKOWY: Safari potrafi NIE dostarczyc drugiego pointerdown
    //     (mimo zwalniania capture wyzej) i pointerowy pinch nigdy nie startuje.
    //     Touchy przychodza zawsze - liczymy z nich TE SAMA matematyke zoomu.
    //     Aktywny wylacznie, gdy pointerowy pinch nie wystartowal (mode !== 'pinch'),
    //     wiec na Androidzie/desktopie nic sie nie dubluje.
    var tpActive = false, tpDist = 0, tpScale = 1, tpMid = null, tpCenter = null, tpTx = 0, tpTy = 0;
    // pan JEDNYM palcem w trybie double-tap (user 2026-08-04: "double tap,
    // zobaczyc podeszwe, przesunac wyzej zeby zobaczyc sznurowki") - zbrojony
    // z DOTYKU, bo pointery na Safari bywaja polykane (cala saga wyzej);
    // na desktopie myszka dalej prowadzi pointerowy 'pan'
    var tpPan = false, tpPanX = 0, tpPanY = 0, tpPanDecided = false;
    function tpArm(t0, t1) {
      tpActive = true;
      tpPan = false;
      mode = null; // przerwij ewentualny swipe z pierwszego palca
      if (rafId) { cancelAnimationFrame(rafId); rafId = null; pendingX = null; }
      applyTrack(-index * trackW, false);
      setImgTransition(index, false); // zywy gest bez wygladzania
      tpDist = Math.hypot(t0.clientX - t1.clientX, t0.clientY - t1.clientY);
      var z = zoom[index]; tpScale = z.sc; tpTx = z.tx; tpTy = z.ty;
      tpMid = { x: (t0.clientX + t1.clientX) / 2, y: (t0.clientY + t1.clientY) / 2 };
      var r = imgs[index].getBoundingClientRect();
      tpCenter = { x: r.left + r.width / 2, y: r.top + r.height / 2 };
    }
    // 🚨 NON-passive + preventDefault juz na touchstart drugiego palca: iOS
    // potrafi rozstrzygnac gest natywny W MOMENCIE dotkniecia (zanim poleci
    // pierwszy touchmove) - pasywny touchstart nie mial jak tego zablokowac.
    // Pojedynczy palec NIE jest preventowany (klik/double-tap dzialaja).
    track.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        e.preventDefault();
        if (mode !== 'pinch' && !gsActive) tpArm(e.touches[0], e.touches[1]);
      } else if (e.touches.length === 1 && zoom[index].sc > 1.03 && !gsActive && !tpActive) {
        // 🚨 BEZ preventDefault: tap bez ruchu ma dalej wygenerowac click,
        // inaczej double-tap przestalby ODDALAC. Pan preventuje dopiero touchmove.
        tpPan = true; tpPanX = e.touches[0].clientX; tpPanY = e.touches[0].clientY;
        tpPanDecided = false; // os gestu rozstrzygana pierwszymi ~8px ruchu
        panOver = 0;
        setImgTransition(index, false);
      }
    }, { passive: false });
    track.addEventListener('touchmove', function (e) {
      if (tpPan && e.touches && e.touches.length === 1) {
        e.preventDefault();
        var tp = e.touches[0];
        if (!tpPanDecided) {
          var adx = Math.abs(tp.clientX - tpPanX), ady = Math.abs(tp.clientY - tpPanY);
          if (adx < 8 && ady < 8) return; // za wczesnie na decyzje o osi
          if (adx > ady) { tpPan = false; panToSwipe(tp.clientX); return; } // poziomo = swipe
          tpPanDecided = true; // pionowo = pan widoku
        }
        var zp = zoom[index];
        var candT = zp.tx + (tp.clientX - tpPanX);
        var imT = imgs[index];
        var mxT = Math.max(0, (imT.clientWidth * zp.sc - imT.clientWidth) / 2);
        var clT = Math.max(-mxT, Math.min(mxT, candT));
        panOver += candT - clT;
        zp.tx = clT;
        zp.ty += tp.clientY - tpPanY;
        tpPanX = tp.clientX; tpPanY = tp.clientY;
        clampZoom(index); applyImg(index);
        if (Math.abs(panOver) > 34) { tpPan = false; panToSwipe(tp.clientX); }
        return;
      }
      if (!e.touches || e.touches.length !== 2) return;
      e.preventDefault(); // zawsze przy 2 palcach: gasi pinch viewportu iOS
      if (gsActive) return; // na Safari pinch prowadzi sterownik GestureEvent
      // 🚨 LENIWE UZBROJENIE: gdy pointerowy pinch wystartowal i Safari go
      // ANULOWALO w locie (pointercancel), touchstart juz nie wroci - zbroimy
      // fallback z pierwszego touchmove z dwoma palcami.
      if (!tpActive) {
        if (mode === 'pinch') return;
        tpArm(e.touches[0], e.touches[1]);
        return;
      }
      var t0 = e.touches[0], t1 = e.touches[1];
      var d = Math.hypot(t0.clientX - t1.clientX, t0.clientY - t1.clientY);
      var m = { x: (t0.clientX + t1.clientX) / 2, y: (t0.clientY + t1.clientY) / 2 };
      if (!tpDist) { tpDist = d; tpMid = m; return; }
      // PRZYROSTOWO (user 2026-08-04): skala wokol BIEZACEGO srodka palcow,
      // a przesuwanie palcow po ekranie panuje WIDOK ZDJECIA (nie tasme);
      // punkt zdjecia spod centroidu zostaje pod palcami
      var z = zoom[index];
      var ns = Math.min(4, Math.max(1, z.sc * (d / tpDist))); var q = ns / z.sc;
      z.tx = (m.x - tpCenter.x) - (tpMid.x - tpCenter.x - z.tx) * q;
      z.ty = (m.y - tpCenter.y) - (tpMid.y - tpCenter.y - z.ty) * q;
      z.sc = ns; tpDist = d; tpMid = m;
      clampZoom(index); applyImg(index);
    }, { passive: false });
    function tpEnd(e) {
      if (!tpActive) return;
      if (e.touches && e.touches.length >= 2) return;
      tpActive = false;
      animateImgTo(index, 1, 0, 0); // smycz - jak w pointerowym pinchu
      mode = null;
    }
    track.addEventListener('touchend', tpEnd);
    track.addEventListener('touchcancel', tpEnd);
    // 🚨 RESYNC MAPY POINTEROW (user 2026-08-04: "po pinchu przestal dzialac
    // swipe"): Safari podczas gestu POLYKA pointerup - w pts zostawal martwy
    // pointer-duch i kazdy nastepny pojedynczy palec byl liczony jako DRUGI
    // (pts.size===2 => pinch zamiast swipe), na zawsze. Zero palcow na ekranie
    // (touchend/touchcancel z pustym touches) to prawda absolutna: czyscimy
    // mape i tryb. Przy normalnym swipe pointerup zdazyl juz zrobic goTo
    // (leci przed touchend), wiec resync niczego nie psuje.
    function ptsResync(e) {
      if (!e.touches || e.touches.length === 0) {
        pts.clear();
        tpPan = false;
        // 🚨 zawieszony gest Safari: gestureend potrafi nie przyjsc - zero palcow
        // na ekranie = gest skonczony na pewno; domykamy smycza recznie
        if (gsActive) { gsActive = false; animateImgTo(index, 1, 0, 0); }
        mode = null;
        // SAMONAPRAWA tasmy (zrzut usera 2026-08-04: licznik 1/9, tasma
        // zawieszona miedzy slajdami): po opadnieciu wszystkich palcow, gdy
        // zaden tryb ani tween nie zyje, tasma MUSI stac rowno na slajdzie.
        // 450ms = po ewentualnym goTo (200ms) i smyczy (320ms).
        setTimeout(function () {
          if (fingersDown === 0 && mode === null && !tpActive && !gsActive) {
            applyTrack(-index * trackW, false);
          }
        }, 450);
      }
    }
    track.addEventListener('touchend', ptsResync);
    track.addEventListener('touchcancel', ptsResync);

    // double-tap zoom - ANIMOWANY w obie strony (user 2026-08-04), przyblizenie
    // dociaga do PUNKTU tapniecia (clampZoom pilnuje krawedzi)
    var lastTap = 0;
    track.addEventListener('click', function (e) {
      // 🚨 DESKTOP: po przeciagnieciu (swipe/pan) przegladarka i tak strzela
      // click przy pointerup - to NIE jest tap i nie moze zbroic double-tapa
      // (dwa szybkie swipe'y robily zoom). Na dotyku click po ruchu nie leci,
      // wiec guard niczego nie zmienia; swMoved zerowany przy kazdym pointerdown.
      if (Math.abs(swMoved) > 6) { swMoved = 0; lastTap = 0; return; }
      var now = Date.now();
      if (now - lastTap < 300) {
        e.preventDefault();
        var z = zoom[index];
        if (z.sc > 1.03) {
          animateImgTo(index, 1, 0, 0);
        } else {
          var k = 2.5;
          var r = imgs[index].getBoundingClientRect();
          var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
          var hasPt = (e.clientX || e.clientY); // syntetyczne kliki bez wspolrzednych -> srodek
          var tapX = hasPt ? e.clientX : cx, tapY = hasPt ? e.clientY : cy;
          animateImgTo(index, k, (tapX - cx) * (1 - k), (tapY - cy) * (1 - k));
        }
        // double-tap SKONSUMOWANY: trzeci szybki klik nie moze zlozyc sie
        // z drugim w kolejny toggle (out->in przy potrojnym kliku na PC)
        lastTap = 0;
        return;
      }
      lastTap = now;
    });

    // SCROLL-ZOOM na desktopie (user 2026-08-04: "podobnie jak scroll, tak jak
    // jest w photoswipe"): kolko/touchpad nad zdjeciem przybliza DO PUNKTU
    // KURSORA (punkt spod kursora stoi w miejscu - ta sama matematyka co pinch,
    // z m = kursor). Zoom TRWALY jak po double-tapie: drag myszka = pan,
    // poziomy drag = normalny swipe ze smycza, double-click = powrot do 1:1.
    // Oddalenie do konca laduje idealnie w 1:1 (clampZoom zeruje tx/ty przy
    // sc=1). Ctrl+wheel (pinch na touchpadzie) idzie ta sama sciezka;
    // preventDefault gasi natywne powiekszanie strony.
    lb.addEventListener('wheel', function (e) {
      if (!lb.classList.contains('is-open')) return;
      e.preventDefault();
      if (mode !== null || tpActive || gsActive || fingersDown >= 2) return;
      var dy = e.deltaY;
      if (e.deltaMode === 1) dy *= 16; else if (e.deltaMode === 2) dy *= lb.clientHeight;
      var z = zoom[index];
      var ns = Math.min(4, Math.max(1, z.sc * Math.exp(-dy * 0.0022)));
      if (ns === z.sc) return;
      var q = ns / z.sc;
      // 🚨 PRZED pomiarem recta domknij animacje w locie: smycz/double-tap
      // (stan juz = cel, klamie tylko transition) i przelot tasmy po strzalce
      // (rect przesuniety o niedojechany dystans -> kotwica w kosmosie);
      // zdjecie transition + snap tasmy urealniaja rect synchronicznie
      setImgTransition(index, false);
      applyTrack(-index * trackW, false);
      // srodek zdjecia BEZ zooma: rect jest po transformacji, ale scale wokol
      // srodka go nie rusza, wiec rectCenter = c0 + (tx,ty) -> odejmujemy
      var r = imgs[index].getBoundingClientRect();
      var cx = r.left + r.width / 2 - z.tx, cy = r.top + r.height / 2 - z.ty;
      var mx = e.clientX || cx, my = e.clientY || cy;
      z.tx = (mx - cx) - (mx - cx - z.tx) * q;
      z.ty = (my - cy) - (my - cy - z.ty) * q;
      z.sc = ns;
      clampZoom(index); applyImg(index);
    }, { passive: false });
  })();
